import React from 'react';

// PrivacyPolicy Component
const Privacy = () => {
  return (
    <div className="policy-container">
      <style>{`
        /* Basic Reset & Font */
     

        /* Container Styling */
        .policy-container {
          margin: 20px auto;
          padding: 120px 7%;
          line-height: 1.7;
        }
         .terms {
      color: #f3b200;
        }

        /* Headings */
        .policy-container h1 {
          font-size: 2.5em;
          color: #212529;
          margin-bottom: 25px;
          text-align: center;
          border-bottom: 2px solid #e9ecef;
          padding-bottom: 15px;
        }

        .policy-container h2 {
           font-size: 22px;
    color: #212529;
    margin-top: 16px;
    margin-bottom: 10px;
    font-family: 'Poppins';

        }

        .policy-container h3 {
          font-size: 1.4em;
          color: #343a40;
          margin-top: 20px;
          margin-bottom: 10px;
        }

        /* Paragraphs */
        .policy-container p {
          margin-bottom: 1em;
          font-size: 1em;
        }

        /* Lists */
        .policy-container ul {
          list-style: disc;
          margin-left: 25px;
          margin-bottom: 1em;
        }

        .policy-container ol {
          list-style: decimal;
          margin-left: 25px;
          margin-bottom: 1em;
        }

        .policy-container li {
          margin-bottom: 0.5em;
        }

        /* Links */
        .policy-container a {
      
          text-decoration: none;
        }

        .policy-container a:hover {
          text-decoration: underline;
        }

        /* Responsive Adjustments */
        @media (max-width: 768px) {
          .policy-container {
            margin: 15px;
            padding: 20px;
          }

          .policy-container h1 {
            font-size: 2em;
            margin-bottom: 20px;
          }

          .policy-container h2 {
            font-size: 20px;
            margin-top: 25px;
          }

          .policy-container h3 {
            font-size: 1.2em;
            margin-top: 18px;
          }

          .policy-container p {
            font-size: 0.95em;
          }
        }

        @media (max-width: 767px) {
          .policy-container {
            margin: 10px;
            padding: 15px;
            border-radius: 8px;
          }

          .policy-container h1 {
            font-size: 1.8em;
            margin-bottom: 15px;
            padding-bottom: 10px;
          }

          .policy-container h2 {
          
    color: #212529;
    margin-top: 16px;
    margin-bottom: 10px;
    font-family: 'Poppins';
        line-height: 26px;

          }

          .policy-container h3 {
            font-size: 1.1em;
            margin-top: 15px;
          }

          .policy-container ul,
          .policy-container ol {
            margin-left: 20px;
          }
        }
      `}</style>

      <h1>Privacy Policy </h1>
      <p><em>Last updated: June 22, 2025</em></p>

      <p>This Privacy Policy describes how Haronics ("we," "us," or "our") collects, uses, and discloses your personal data when you visit our website Haronics (the "Site") and use our services. By accessing or using the Site, you agree to the terms of this Privacy Policy. If you do not agree with the terms, please do not use the Site.</p>

      <h2>1. What Personal Data We Collect and Why We Collect It</h2>

      <h3>Comments</h3>
      <p>When visitors leave comments on the site we collect the data shown in the comments form, and also the visitor’s IP address and browser user agent string to help spam detection.</p>
      <p>An anonymized string created from your email address (also called a hash) may be provided to the Gravatar service to see if you are using it. The Gravatar service privacy policy is available here: https://automattic.com/privacy/. After approval of your comment, your profile picture is visible to the public in the context of your comment.</p>

      <h3>Media</h3>
      <p>If you upload images to the website, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.</p>

      <h3>Contact Forms</h3>
      <p>If you use our contact forms, we collect the information you provide (e.g., name, email address, message) to respond to your inquiries and provide customer support.</p>


      <h3>Embedded Content from Other Websites</h3>
      <p>Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.</p>
      <p>These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.</p>

      <h3>Analytics</h3>
      <p>We use analytics services to understand how visitors engage with our Site. This may involve collecting data such as your IP address, browser type, operating system, referring URLs, and pages viewed. This data is used in an aggregated and anonymized form for site improvement and performance monitoring.</p>

      <h2>2. How Long We Retain Your Data</h2>
      <p>If you leave a comment, the comment and its metadata are retained indefinitely. This is so we can recognize and approve any follow-up comments automatically instead of holding them in a moderation queue.</p>
      <p>For users that register on our website (if any), we also store the personal information they provide in their user profile. All users can see, edit, or delete their personal information at any time (except they cannot change their username). Website administrators can also see and edit that information.</p>

      <h2>3. What Rights You Have Over Your Data</h2>
      <p>If you have an account on this site, or have left comments, you can request to receive an exported file of the personal data we hold about you, including any data you have provided to us. You can also request that we erase any personal data we hold about you. This does not include any data we are obliged to keep for administrative, legal, or security purposes.</p>

      <h2>4. Where Your Data Is Sent</h2>
      <p>Visitor comments may be checked through an automated spam detection service.</p>
      <p>Data may also be processed by third-party service providers (e.g., hosting providers, analytics services) acting on our behalf and under our instructions.</p>

      <h2>5. Data Protection Measures</h2>
      <p>We implement a variety of security measures to maintain the safety of your personal information when you enter, submit, or access your personal information.</p>

      <h2>6. Third-Party Data Sources</h2>
      <p>We may receive information about you from third-party sources if you choose to connect with us through social media platforms or other third-party services.</p>

      <h2>7. Automated Decision-Making and Profiling</h2>
      <p>We do not use automated decision-making processes or profiling that would significantly affect you.</p>

      <h2>8. Data Breach Procedures</h2>
      <p>In the event of a data breach, we have procedures in place to assess, address, and notify relevant authorities and affected individuals as required by applicable law.</p>

      <h2>9. Changes to This Privacy Policy</h2>
      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

      <h2>10. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at: <a href="haronicsindia@gmail.com" className='terms'>haronicsindia@gmail.com</a></p>
    </div>
  );
};

export default Privacy;
